module.exports = __webpack_public_path__ + "static/media/Time.d3550a64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/NewTimeline/assets/Time.svg
// module id = 266
// module chunks = 0